import HubSpotIntegration from '../../../HubSpotIntegration/HubSpotIntegration';
import type { ConnectionCardProps } from '../../types';

const HubSpotConnectionCard: React.FC<ConnectionCardProps> = () => {
  return <HubSpotIntegration />;
};

export default HubSpotConnectionCard;
